import React, { useState, useEffect, useContext,  useMemo } from "react";
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import LoaderAnimation from "pages/LoaderAnimation";
import { Utils } from "common/Utils";

export default function ComplianceEnrollments ({isActive, complianceId, setComplianceEnrollmentsComplete, isViewOnly, completedMessage}) {
    const { error } = useContext(PrivateRoutesContext);
    
    const [complianceEnrollments, setComplianceEnrollments] = useState(null);
    const [isLoadingComplianceEnrollments, setIsLoadingComplianceEnrollments] = useState(false);
    const [enrollmentApproval, setEnrollmentApproval] = useState([]);
    const [doShowCensusDialog, setDoShowCensusDialog] = useState(false);

    useEffect(() => {
        if (isActive || isViewOnly) {
            getComplianceEnrollments();
        }
    },[isActive, isViewOnly, complianceId])

    useEffect(() => {
        if (complianceEnrollments?.enrollments) {
            setEnrollmentApproval(complianceEnrollments.enrollments.map(r => !r.doRequireApproval))
        }
        else {
            setEnrollmentApproval([]);
        }
    },[complianceEnrollments])

    useEffect(() => {
        var canComplete = !(enrollmentApproval && enrollmentApproval.length > 0 && enrollmentApproval.every(c => c));

        setComplianceEnrollmentsComplete(canComplete);
    },[enrollmentApproval]);

    const getComplianceEnrollments = () => {
        if (complianceId) {
            setIsLoadingComplianceEnrollments(true);
            setComplianceEnrollments(null);

            apiGet(apiUrls.getComplianceEnrollments(complianceId)).then(response => {
                if (response.data) {
                    setComplianceEnrollments(response.data);
                }
            }).catch(response => {
                console.log(response, "error");
                error.setTitle("An Error Occurred");
                error.setText("An Error occurred loading enrollments.");
                error.setDoShowError(true);
            }).finally(() => {
                setIsLoadingComplianceEnrollments(false);
            });
        }
    }

    return (
        <Box>
            <Box className="container ">
                {isLoadingComplianceEnrollments ?
                    <LoaderAnimation />
                : complianceEnrollments && complianceEnrollments.enrollments ?
                <>
                    <Box className="row">
                        <Box className="col"></Box>
                        <Box className="col-2 border border-dark">
                            <strong>Benefit Type</strong>
                        </Box>
                        <Box className="col-2 border border-dark">
                            <strong>Current: {Utils.formatDate(complianceEnrollments.currentPeriod)}</strong>
                        </Box>
                        <Box className="col-2 border border-dark">
                            <strong>Prior:  {Utils.formatDate(complianceEnrollments.priorPeriod)}</strong>
                        </Box>
                        <Box className="col-1 border border-dark">
                            <strong>Approve<sup>1</sup></strong>
                        </Box>
                        <Box className="col"></Box>
                    </Box>
                    {complianceEnrollments.enrollments.map((e,i) => 
                        <Box className="row">
                            <Box className="col"></Box>
                            <Box className="col-2 border border-dark">
                                {e.benefitTypeName}
                            </Box>
                            <Box className="col-2 border border-dark text-end">
                                {e.currentPeriod}
                            </Box>
                            <Box className="col-2 border border-dark text-end">
                                {e.previousPeriod}
                            </Box>
                            <Box className="col-1 border border-dark text-center">
                                {e.doRequireApproval ? 
                                    <Checkbox
                                        checked={enrollmentApproval[i] || isViewOnly}
                                        onChange={() => setEnrollmentApproval((prevState) => {
                                            let s = [...prevState];
                                            s[i] = !s[i];
                                            return s;
                                        })}
                                        disabled={isViewOnly}
                                    />
                                : null}
                            </Box>
                            <Box className="col"></Box>
                        </Box>)
                    }
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2}}>
                        <strong><sup>1</sup>Note: All deviations above 10% require approval</strong>
                    </Box>
                </> : null}
            </Box>
            {completedMessage ? 
                <Box sx={{ display: 'flex', justifyContent: 'center'}}>
                    <h3>{completedMessage}</h3>
                </Box>
            : null}
            {/* <Box sx={{ display: 'flex', justifyContent: 'right'}}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setDoShowCensusDialog(true)}
                    disabled={complianceEnrollments == null}
                >
                    See Details
                </Button>
            </Box> */}
            <Dialog
                open={doShowCensusDialog}
                onClose={() => setDoShowCensusDialog(false)}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogTitle id="alert-dialog-title">
                    {`Census`}
                </DialogTitle>
                <DialogContent>
                    This is where the details go!
                </DialogContent>

                <DialogActions>
                    <Button variant="outlined" onClick={() => setDoShowCensusDialog(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}